import {
  SocialExportGetStationConnectionStateDto,
  useSocialExportListConnectionsByStation,
} from '@mi-front/api-v2';

/**
 * Raw social-export connections assigned to a station, plus a loading gate.
 * Prefer {@link useStationPlatformConnections} when filtering by platform.
 */
export function useStationConnections(stationId: string | undefined) {
  const connectionsQuery = useSocialExportListConnectionsByStation(stationId ?? '', {
    query: { enabled: !!stationId },
  });

  const connections: SocialExportGetStationConnectionStateDto[] =
    connectionsQuery.data?.results ?? [];

  // Require stationId before treating the list as resolved; otherwise an empty list
  // flashes "no connections" while the fragment/composition station is still loading.
  const areConnectionsResolved = !!stationId && !connectionsQuery.isLoading;

  return {
    connectionsQuery,
    connections,
    areConnectionsResolved,
  };
}
